import React from "react"
import { Text } from "@chakra-ui/react"

type Props = {
  optedInWhatsapp: boolean;
}

const WhatsAppOptInCell = ({ optedInWhatsapp }: Props) => (
  optedInWhatsapp ? <Text fontSize="sm" noOfLines={1}>Opted In</Text> : null
)

export default WhatsAppOptInCell
